import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { SectionHeader, Tooltip } from "../../../../app/components";
import SpecialRadioButton from "../../../../app/components/special.radiobutton";
import SeparateContainer from "../../../../app/components/separate.Container";
import SideBySide from "../../../../app/components/sideBySide";

const headerData = [
  { text: "Planned", flex: 2 },
  { text: "Actual", flex: 2 },
  { text: "Other", flex: 2 },
];

export default function CountryEnrollRate({
  errors,
  touched,
  values,
  setValues,
}) {
  const renderCountryEnrollmentRate = () => {
    return values?.siteGroups?.map((siteGroup, index) => {
      return (
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="scenario"
            name="scenarios"
            value={siteGroup.enrollmentRateSelection}
            onChange={(e) => {
              if (!e.target.value) return;
              let siteGroupLocal = siteGroup;
              siteGroupLocal["enrollmentRateSelection"] = parseFloat(
                e.target.value,
              );
              let siteGroups = values.siteGroups.map((sg, i) => {
                if (i === index) return siteGroupLocal;
                return sg;
              });
              setValues({ ...values, siteGroups });
            }}
          >
            <Row>
              <Cell flex={1}>
                <Typography style={{ textAlign: "left", width: "100%" }}>
                  {siteGroup.siteGroupName}
                </Typography>
              </Cell>
              <Cell flex={2}>
                {!(siteGroup?.enrollmentRatePlanned === null) && (
                  <FormControlLabel
                    style={{ minWidth: "5rem" }}
                    value={1}
                    control={<Radio color="primary" />}
                    label={siteGroup?.enrollmentRatePlanned}
                  />
                )}
              </Cell>
              <Cell flex={2}>
                {!(siteGroup?.enrollmentRateActual === null) && (
                  <FormControlLabel
                    style={{ minWidth: "5rem" }}
                    value={2}
                    control={<Radio color="primary" />}
                    label={siteGroup?.enrollmentRateActual}
                  />
                )}
              </Cell>
              <Cell flex={2}>
                <SpecialRadioButton
                  type="number"
                  maxDecimals={2}
                  currentRadioValue={3}
                  disabled={siteGroup.enrollmentRateSelection !== 3} 
                  onChange={(value) => {
                    let siteGroupLocal = siteGroup;
                    siteGroupLocal["enrollmentRateOther"] = parseFloat(value);
                    let siteGroups = values.siteGroups.map((sg, i) => {
                      if (i === index) return siteGroupLocal;
                      return sg;
                    });
                    setValues({ ...values, siteGroups });
                  }}
                  value={siteGroup?.enrollmentRateOther}
                  error={
                    errors?.siteGroups?.length >= index &&
                    !!errors?.siteGroups[index]?.enrollmentRateOther
                  }
                />
              </Cell>
            </Row>
          </RadioGroup>
        </FormControl>
      );
    });
  };

  return (
    <Container>
      <SeparateContainer>
        <SideBySide>
          <SectionHeader
            hasStartAdornment={false}
            paddingBottom={false}
            endAdornment={
              <Tooltip
                changeColor={true}
                info="Select the enrollment rates you want to use in the re-model. You can chose the planned rate, the actual rate or input a new rate for each country."
              />
            }
          >
            Country - Enrollment Rate (p/s/m)
          </SectionHeader>
        </SideBySide>

        <TableContainer>
          <Table>
            <Row>
              <Cell
                variant="header"
                flex={1}
              ></Cell>
              {headerData.map(({ text, flex }, index) => (
                <Cell
                  key={text}
                  variant="header"
                  flex={flex}
                >
                  <Typography align="center">
                    <strong>{text}</strong>
                  </Typography>
                </Cell>
              ))}
            </Row>
            {renderCountryEnrollmentRate()}
          </Table>
        </TableContainer>
        {errors.countryEnrollment && (
          <ErrorMessageContainer className="MuiFormHelperText-root">
            {errors.countryEnrollment}
          </ErrorMessageContainer>
        )}
      </SeparateContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2em;
`;

const TableContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
  padding: 10px 20px 20px 20px;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-between;
  flex-grow: 1;
  height: 6em;
`;

const Cell = styled.div`
  background: ${(p) =>
    p.variant === "header" ? "var(--surface-50)" : "white"};
  flex: ${(p) => p.flex || "1"};
  align-items: center;
  justify-content: ${(p) => p.alignText || "center"};
  display: flex;
  border-bottom: 1px solid var(--surface-300);
  padding: 1em;
  padding-left: 3em;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid var(--surface-300);
  border-radius: 4px;
  border-bottom: none;
`;

const ErrorMessageContainer = styled.div`
  color: #f44336 !important;
  margin: 3px 14px !important;
`;
